import { Outlet, useNavigate } from 'react-router-dom';
import { Menubar } from 'primereact/menubar';
import { Button } from 'primereact/button';

const AdminShell = () => {
  const navigate = useNavigate();

  const topMenu = [
    {
      label: 'Cerrar sesión',
      icon: 'pi pi-sign-out',
      command: () => {
        console.log('Cerrar sesión');
      }
    }
  ];

  const sidebarItems = [
    { label: 'Dashboard', icon: 'pi pi-home', path: '/admin' },
    { label: 'Usuarios', icon: 'pi pi-users', path: '/admin/usuarios' },
    { label: 'Ajustes', icon: 'pi pi-cog', path: '/admin/ajustes' }
  ];

  return (
    <div className="min-h-screen flex flex-col bg-gray-900 text-white">
      {/* Header */}
      <div className="flex-none">
      </div>

      {/* Body: Sidebar + Main */}
      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar */}
        <aside className="w-60 bg-gray-800 p-4 border-r border-gray-700">
          <h3 className="text-xl font-bold mb-6">Admin</h3>
          <ul className="space-y-3">
            {sidebarItems.map(item => (
              <li key={item.path}>
                <Button
                  label={item.label}
                  icon={item.icon}
                  className="w-full justify-start"
                  severity="secondary"
                  outlined
                  onClick={() => navigate(item.path)}
                />
              </li>
            ))}
          </ul>
        </aside>

        {/* Main Content */}
        <main className="flex-1 p-6 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminShell;
